import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Shield, Lock, Eye, Edit, Trash2, ArrowLeft } from 'lucide-react';
import { useAuth } from '@/components/AuthProvider';

export function ConfiguracaoPermissoes() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const permissoes = [
    {
      nome: 'Visualização Pública',
      descricao: 'Permitir que clientes visualizem orçamentos e pedidos públicos',
      status: true,
      icon: Eye
    },
    {
      nome: 'Edição de Dados',
      descricao: 'Permitir alterações em dados da empresa e produtos',
      status: true,
      icon: Edit
    },
    {
      nome: 'Exclusão de Registros',
      descricao: 'Permitir exclusão permanente de pedidos, orçamentos e clientes',
      status: false,
      icon: Trash2
    },
    {
      nome: 'Segurança de Dados',
      descricao: 'Proteger dados sensíveis com criptografia',
      status: true,
      icon: Lock
    }
  ];

  return (
    <div className="px-6 py-6 space-y-6">
      <div className="space-y-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/configuracoes')}
          className="mb-2 text-purple-600 hover:bg-purple-100"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Voltar
        </Button>
        <h1 className="text-3xl font-bold">Permissões do Sistema</h1>
        <p className="text-gray-500 mt-1">Configure as permissões gerais de acesso do seu sistema</p>
      </div>

      {user?.user_metadata?.email === 'brunobgs1888@gmail.com' && (
        <Card className="border-amber-200 bg-amber-50">
          <CardContent className="pt-6">
            <p className="text-sm text-amber-800">
              ℹ️ Você é o proprietário da conta. As configurações de permissão aqui afetam todos os operadores.
            </p>
          </CardContent>
        </Card>
      )}

      <div className="grid gap-4">
        {permissoes.map((permissao, index) => {
          const Icon = permissao.icon;
          return (
            <Card key={index}>
              <CardContent className="flex items-center justify-between p-4">
                <div className="flex items-center gap-4">
                  <div className="p-2 bg-blue-100 rounded-lg">
                    <Icon className="w-6 h-6 text-blue-600" />
                  </div>
                  <div>
                    <p className="font-semibold">{permissao.nome}</p>
                    <p className="text-sm text-gray-500">{permissao.descricao}</p>
                  </div>
                </div>
                <Badge variant={permissao.status ? "default" : "secondary"}>
                  {permissao.status ? 'Ativado' : 'Desativado'}
                </Badge>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card className="border-blue-200 bg-blue-50">
        <CardHeader>
          <CardTitle className="text-base flex items-center gap-2">
            <Shield className="w-5 h-5" />
            Sobre Permissões
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-sm text-gray-700">
          <p>
            • <strong>Visualização Pública:</strong> Clientes podem acessar orçamentos e pedidos através de links públicos
          </p>
          <p>
            • <strong>Edição de Dados:</strong> Operadores podem modificar informações de clientes, produtos e serviços
          </p>
          <p>
            • <strong>Exclusão de Registros:</strong> Operadores podem deletar pedidos, orçamentos e outros registros permanentemente
          </p>
          <p>
            • <strong>Segurança de Dados:</strong> Dados sensíveis como CNPJ e dados bancários são criptografados
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
